import SpanService from 'live/services/span'

import { ImageLogAttributes } from 'live-charts/types/image-log'

import { ImageLogEvent, ImageLogState } from '../../types/image-log'

export function getInitialState(): ImageLogState {
    return {
        buffer: [],
        data: [],
        span: {
            begin: 0,
            end: 0
        }
    }
}

export function startQuery(actions: StartFlowMessage, state: ImageLogState): ImageLogState {
    if (!actions?.events) {
        return state
    }

    const newState = {
        span: { begin: 0, end: 0 },
        realtime: SpanService.isRealtime(actions.events.info?.span?.text),
        data: [],
        buffer: []
    }

    return {
        ...state,
        ...newState
    }
}

export function accEvents(action: EventFlowMessage<LiveEvent<ImageLogEvent>>, state: ImageLogState): ImageLogState {
    const property = state.realtime ? 'data' : 'buffer'
    const events = [...state[property]]

    action.events.forEach(event => {
        if (event.timestamp < state.span.begin || event.timestamp > state.span.end) return
        const point: ImageLogAttributes = {
            x: event.timestamp,
            y: event.values
        }
        events.push(point)
    })

    return { ...state, [property]: events }
}

export function reflectSpan(action: SpanFlowMessage, state: ImageLogState): ImageLogState {
    const begin = action.events.begin
    const end = action.events.end

    const newData = state.data.filter(point => point.x >= begin && point.x <= end)

    const span = { begin, end }
    const newState = { ...state, span, data: newData }

    return newState
}

export function endHistory(action: EndHistoryFlowMessage, state: ImageLogState): ImageLogState {
    return { ...state, realtime: true, data: state.buffer, buffer: [] }
}
